import { getLogger } from '@foundation-player/logger';

export const DASH_MIME_TYPES = ['application/dash+xml'];

export const HLS_MIME_TYPES = ['application/x-mpegurl', 'application/vnd.apple.mpegurl'];

/**
 * Check if a video element can play standard manifest extensions
 *
 * @param video - the video element to test
 *
 * @see https://github.com/shaka-project/shaka-player/blob/a3d5dc54ff0e6eacd2af2602037cccabbd525c03/lib/media/manifest_parser.js#L63
 */
export function manifestProbe(video: HTMLVideoElement): Record<string, boolean> {
  const logger = getLogger('player.core.capability.manifestProbe');
  const mimeTypes = [
    ...DASH_MIME_TYPES,
    ...HLS_MIME_TYPES,
    // SmoothStreaming, only for completeness but not used currently
    'application/vnd.ms-sstr+xml',
  ];

  const support: Record<string, boolean> = {};

  for (const mimeType of mimeTypes) {
    const result = video.canPlayType(mimeType);
    support[mimeType] = !!result;
    logger.debug(`Test native manifest support for "${mimeType}"`, { mimeType, supported: result || false });
  }

  return support;
}
